import React from 'react';
import Image from 'next/image';

const ValuePropositionDataEngineering = () => {
    return (
        <div className="section-py relative bg-black">
            <div className="bg-agriculture-numbers">
            <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                <source src="media/aiml-section.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="container xl:container mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-8 grid">
                        <h2 className="text-white mb-2.5">
                            Value Proposition
                        </h2>
                        <p className='dark:text-[#D7DEE5] mb-2.5'>
                            Modern data pipelines, warehouses & infrastructure - production-ready foundations.
                        </p>
                        <p className='dark:text-[#D7DEE5] mb-0'>
                            We build the production-ready data infrastructure that fuels enterprise analytics and AI transformation. Our modern pipelines, cloud data warehouses, and automated foundations turn fragmented data into a strategic asset. By engineering for scalability, observability, and performance, we lay the groundwork for AI maturity, faster deployments, and measurable business impact.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                            loading="lazy"
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Problem we solve</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Fragmented data silos obstruct comprehensive insights, poor data quality leads to flawed decision-making, manual processes drain resources, and analytics infrastructure lacks scalability. Additionally, missing real-time data capabilities, costly legacy systems hinder innovation, and ungoverned data creates compliance risks.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                           width={36}
                                height={36}
                            loading="lazy"
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Core capabilities</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Designing and automating efficient data pipelines with ETL/ELT processes, architecting scalable data warehouses and lakes for unified storage, implementing real-time streaming data processing, ensuring data quality with validation frameworks, migrating cloud data platforms, developing precise data models and schemas, and applying DataOps with infrastructure automation to optimize operations.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                            loading="lazy"
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Outcomes</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Unified, trusted enterprise data ready for AI and analytics, reduced costs through automation, scalable cloud infrastructure enabling real-time intelligence, and compliant, future-ready foundations for enterprise AI adoption.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ValuePropositionDataEngineering;
